var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "mb-0 pb-0", attrs: { cols: "12" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  label: "Parent Code",
                  "item-value": "id",
                  "item-text": "description",
                  "return-object": "",
                  items: _vm.parentCodeList,
                  clearable: ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "item",
                    fn: function({ item }) {
                      return [
                        _c("span", { staticClass: "primary--text" }, [
                          _vm._v(_vm._s(item.account_code))
                        ]),
                        _c("small", { staticClass: "ml-2 blue-grey--text" }, [
                          _vm._v(_vm._s(item.description))
                        ])
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.parentCode,
                  callback: function($$v) {
                    _vm.parentCode = $$v
                  },
                  expression: "parentCode"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "ma-0 py-1", attrs: { cols: "12" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  label: "Account Code",
                  "item-value": "id",
                  "item-text": "description",
                  "return-object": "",
                  dense: "",
                  items: _vm.accountCodeListFiltered
                },
                scopedSlots: _vm._u([
                  {
                    key: "item",
                    fn: function({ item }) {
                      return [
                        _c("span", { staticClass: "primary--text" }, [
                          _vm._v(_vm._s(item.account_code))
                        ]),
                        _c("small", { staticClass: "ml-2 blue-grey--text" }, [
                          _vm._v(_vm._s(item.description))
                        ])
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.accountCode,
                  callback: function($$v) {
                    _vm.accountCode = $$v
                  },
                  expression: "accountCode"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "ma-0 py-1", attrs: { cols: "12" } },
            [
              _c("v-text-field", {
                attrs: { label: "Amount", type: "number", dense: "" },
                model: {
                  value: _vm.amount,
                  callback: function($$v) {
                    _vm.amount = _vm._n($$v)
                  },
                  expression: "amount"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "ma-0 py-1", attrs: { cols: "12" } },
            [
              _c("v-textarea", {
                attrs: { label: "Reason", dense: "", counter: 191 },
                model: {
                  value: _vm.reason,
                  callback: function($$v) {
                    _vm.reason = $$v
                  },
                  expression: "reason"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }